// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-module__primaryButton--2K3GZ{margin-bottom:10px}@media screen and (min-width:756px){.index-module__primaryButton--2K3GZ{margin-bottom:0}}@media screen and (min-width:756px){.index-module__buttonsWrapper--3HVVX{display:flex;justify-content:space-between;flex-direction:row-reverse;gap:10px}}.index-module__button--3iLOc{width:100%}.index-module__title---qd7o{margin-bottom:5px}.index-module__text--3omlX{margin-bottom:20px}.index-module__cancelButton--1N9u0{background-color:#fff}", ""]);
// Exports
exports.locals = {
	"primaryButton": "index-module__primaryButton--2K3GZ",
	"buttonsWrapper": "index-module__buttonsWrapper--3HVVX",
	"button": "index-module__button--3iLOc",
	"title": "index-module__title---qd7o",
	"text": "index-module__text--3omlX",
	"cancelButton": "index-module__cancelButton--1N9u0"
};
module.exports = exports;
